import { FormInstance } from 'antd';
import { setTimeWithSeconds } from '../../helpers';

export const setFieldValues = (exam: any, primaryForm: FormInstance) => {
    const tempExam = {
        ...exam
      }
      delete tempExam.timeInSeconds;
      primaryForm.setFieldsValue(tempExam);
      
      if (exam) {
        primaryForm.setFieldValue("categories", exam.categories.map((category: any) => category.id));
        primaryForm.setFieldsValue({
          timeInSeconds: setTimeWithSeconds(exam.timeInSeconds)
        });
      
      }
}